import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.xray.experiments_runtime_v6');
import { OnInit, Input } from '@angular/core';

@Component({ standalone: false,
    selector: 'wiz-page-xray-experiments_runtime_v6',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.xray.experiments_runtime_v6/view.scss */
/* src/app/page.xray.experiments_runtime_v6/view.scss: no such file or directory */`],
})
export class PageXrayExperiments_runtime_v6Component implements OnInit {
    @Input() title: any;

    public async ngOnInit() {
    }
}

export default PageXrayExperiments_runtime_v6Component;